import { CreateUserPayload, UpdateUserPayload, User, UsersFilterParams } from "../@types/users";
import { formatGetAllUsers, formatUser } from "./formatters/users";
import { axiosInstance } from ".";

export const getAllUsers = async (filters?: UsersFilterParams): Promise<User[]> => {
  const params = new URLSearchParams();
  if (typeof filters?.isDriver === 'boolean') {
    params.append('isDriver', filters.isDriver ? '1' : '0');
  }
  const query = params.toString();
  const queryString = query ? `?${query}` : '';
  const result = await axiosInstance.get(`/get-users.php${queryString}`);

  return formatGetAllUsers(result.data);
};

export const createUser = async (payload: CreateUserPayload): Promise<User> => {
  const result = await axiosInstance.post('/create-user.php', payload);
  
  return formatUser(result.data.createdUser);
};

export const updateUser = async (payload: UpdateUserPayload): Promise<User> => {
  const result = await axiosInstance.post('/update-user.php', payload);

  return formatUser(result.data.updatedUser);
};
